module.exports = __webpack_public_path__ + "static/1-before.d79c9859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1-before.jpg
// module id = 420
// module chunks = 221374088121123